import React from "react";
import { Navigate } from "react-router-dom"; // Importar Navigate
import PropTypes from "prop-types"; // Importar PropTypes

// Componente ProtectedRoute para proteger las rutas privadas
function ProtectedRoute({ children }) {
  const token = localStorage.getItem("authToken"); // Obtener el token del localStorage

  if (!token) {
    // Si no hay token, redirigir al login
    return <Navigate to="/authentication/sign-in" />;
  }

  // Si hay token y es válido (no necesitas decodificarlo), permitir el acceso a la ruta protegida
  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired, // Validación de las props de tipo 'children'
};

export default ProtectedRoute;
